import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useGiftData } from "../../../lib/useMockData";

export default function DeliverySection() {
  const { deliveryData } = useGiftData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{deliveryData.label}</p>
              <h2 className="section-title">{deliveryData.title}</h2>
            </div>
          </ScrollReveal>

          {/* 受取り方法 */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-14 md:mb-16">
            {deliveryData.methods.map((m, idx) => (
              <ScrollReveal key={m.title} direction="up" delay={idx * 100}>
                <div className="bg-airdoa-cream rounded-lg p-6 md:p-8 h-full text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-5">
                    <i className={`${m.icon} text-xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy mb-2">
                    {m.title}
                  </h3>
                  <p className="text-sm text-airdoa-gray leading-relaxed">
                    {m.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* ボックスの中身 */}
          <ScrollReveal direction="up" delay={150}>
            <div className="bg-airdoa-cream rounded-xl overflow-hidden border border-airdoa-gray-light/30">
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="aspect-[4/3] md:aspect-auto overflow-hidden">
                  <img
                    src={deliveryData.packaging.image}
                    alt="ギフトボックスの中身"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 md:p-10 flex flex-col justify-center">
                  <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
                    WHAT'S INSIDE
                  </p>
                  <h3 className="text-xl md:text-2xl font-serif font-semibold text-airdoa-navy mb-6">
                    {deliveryData.packaging.title}
                  </h3>
                  <ul className="space-y-4">
                    {deliveryData.packaging.items.map((item) => (
                      <li
                        key={item.label}
                        className="flex items-start gap-3"
                      >
                        <span className="w-5 h-5 flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mt-0.5 shrink-0">
                          <i className="ri-check-line text-xs" />
                        </span>
                        <div>
                          <p className="text-sm font-medium text-airdoa-navy">
                            {item.label}
                          </p>
                          <p className="text-xs text-airdoa-gray mt-0.5">
                            {item.desc}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}